import util from '@bmp-vue/core/api/util'

const controller = 'Asigni'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  PostAsigni: function (acao, codigoIntegracao, dto, codigoPortal) {
    var request = { Dto: dto, Acao: acao, CodigoIntegracao: codigoIntegracao, CodigoPortal: codigoPortal }

    return util.Axios.Post(`${controller}/PostAsigni`, request)
  }
})
